@use '@konova/styles/styles';

.root {
  width: 100%;
  max-width: styles.$layout-container-width-small;
  padding: 0 12px;
  margin: 0 auto;

  @include styles.mq('min', 'small') {
    max-width: styles.$layout-container-width-medium;
  }
  @include styles.mq('min', 'medium') {
    max-width: styles.$layout-container-width-lg;
  }

  @include styles.mq('min', 'large') {
    max-width: styles.$layout-container-width-xl;
  }
}